$(function ($) {

  $("a.search-toggle").on('click', function (e) {

    $(".header-menubar").toggleClass('search-active');
    e.preventDefault();
  });
  // close when click off of container



  $(".filter-btn").click(function () {
    $(".sidebar-col").addClass("sidebar-open");
  });
  $(".close-btn").click(function () {
    $(".sidebar-col").removeClass("sidebar-open");
  });

  /*Start: Mobile sidebar filters*/
  function filter_popup() {
    $('.mob-filter').magnificPopup({
      delegate: 'a',
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function () {
          this.st.mainClass = this.st.el.attr('data-effect');
        }
      },
      midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
    });

    $('.sidebar-sec').addClass('mfp-hide');
  }
  if ($(window).width() < 1025) {
    filter_popup();
    $('.mfp-content .sidebar-sec').removeClass('mfp-hide');
  }
  $(window).on('resize', function(){
    if ($(window).width() < 1025) {
      filter_popup();
      $('.mfp-content .sidebar-sec').removeClass('mfp-hide');
    }
    else {
      $('.sidebar-sec').removeClass('mfp-hide');
      $('.mfp-content .sidebar-sec').addClass('mfp-hide');
    }
  });


  /*End: Mobile sidebar filters*/

  /* qwantity start */  

  $("button").on("click", function (ev) {


    var currentQty = $('input[name="quantity"]').val();
    var qtyDirection = $(this).data("direction");
    var newQty = 0;

    if (qtyDirection == "1") {
      newQty = parseInt(currentQty) + 1;
    } else if (qtyDirection == "-1") {
      newQty = parseInt(currentQty) - 1;
    }

    // make decrement disabled at 1
    if (newQty == 1) {
      $(".decrement-quantity").attr("disabled", "disabled");

    }

    // remove disabled attribute on subtract
    if (newQty > 1) {
      $(".decrement-quantity").removeAttr("disabled");
      // alert("test");
    }

    if (newQty > 0) {
      newQty = newQty.toString();
      $('input[name="quantity"]').val(newQty);
    } else {
      $('input[name="quantity"]').val("1");
    }
  });



  /* qwantity end */ 

  /*---------------- Main Slider ------------------*/
  $('.main-slider').slick({    
    infinite: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true
  });

  /*---------------- best-sellers ------------------*/
  $('.best-sellers-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    adaptiveHeight: true,
    arrows: true,
    responsive: [
                 {
                    breakpoint: 1600,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1
                    }
                 },
                 {
                   breakpoint: 1200,
                   settings: {
                     slidesToShow: 4,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 1100,
                   settings: {
                     slidesToShow: 3,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 992,
                   settings: {
                     slidesToShow: 2,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 769,
                   settings: {
                     //                      rows: 2,
                     slidesToShow: 2,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 641,
                   settings: {
                     //                      rows: 2,
                     slidesToShow: 1,
                     slidesToScroll: 1
                   }
                 }

                ]
  });

  $('.testimonial-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,    
    arrows: false,
    responsive: [{
      breakpoint: 1301,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
                 {
                   breakpoint: 1200,
                   settings: {
                     slidesToShow: 3,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 992,
                   settings: {
                     slidesToShow: 3,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 768,
                   settings: {
                     rows: 2,
                     slidesToShow: 2,
                     slidesToScroll: 1
                   }
                 },
                 {
                   breakpoint: 481,
                   settings: {
                     rows: 2,
                     slidesToShow: 1,
                     slidesToScroll: 1
                   }
                 }

                ]
  });

  /* PLP PRODUCTS 	EQUAL HEIGHT Starts  */

  $(window).load(function() {
    equalheight('.prod-img .prodimg');
   // equalheight('.gallery-sec');
    equalheight('.product-inner  .product-inner-image');
    equalheight('.blog .blogimg');
  });

  $(window).resize(function() {
    equalheight('.prod-img .prodimg');
   // equalheight('.gallery-sec');
    equalheight('.product-inner  .product-inner-image');
    equalheight('.blog .blogimg');
  });

  /* PLP PRODUCTS 	EQUAL HEIGHT ends */

var maxHeight = 0;

    $(".product-inner-content .contenttitle").each(function () {
        if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });

  $(".product-inner-content .contenttitle").height(maxHeight);


  /*---------------- best-sellers Mobile ------------------*/


  if ($(window).width() < 769) { 
    $('.best-sellers-slider-mobile').slick({     
      adaptiveHeight: true,
      infinite: true,     

      arrows: false,
      dots: false,  
      rows: 2, 
      slidesPerRow: 2,
      responsive: [
        {
          breakpoint: 414,
          settings: {
            slidesPerRow: 1        
          }
        }
      ]
    });

  } 



  /*---------------- Responsive Menu ------------------*/




  $(".nav-trigger").on('click', function (e) {
    $("body").toggleClass('off-canvas-body');
    $(".menu-bar").toggleClass("off-canvas");
    e.preventDefault();
  });
  if ($(window).width() < 992) {
    //     $(".site-nav__dropdown").each(function () {
    //       $(this).slideUp(600);
    //     });
    $('.site-nav--has-dropdown.dropdown').on("click", "button", function (e) {
      // e.stopPropagation();
      // e.preventDefault();
      // alert($(this).addClass("test"));

      $(this).next('.site-nav__dropdown').slideToggle(600);
      //$(this).find('span').toggleClass('new-arrow-up');

    });
  }




  /*---------------- Search Popup ------------------*/




  function slickInit() {
    $(".best-sellers-slider2").slick({
      dots: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 1600,
        settings: {
          slidesToShow: 4
        }
      },

                   {
                     breakpoint: 1400,
                     settings: {
                       slidesToShow: 4
                     }
                   },

                   {
                     breakpoint: 1200,
                     settings: {
                       slidesToShow: 4
                     }
                   },

                   {
                     breakpoint: 940,
                     settings: {
                       slidesToShow: 3
                     }
                   }, {
                     breakpoint: 767,
                     settings: {
                       slidesToShow: 3
                     }
                   }, {
                     breakpoint: 568,
                     settings: {
                       slidesToShow: 2
                     }
                   }
                  ]
    });
  }



  slickInit();

  $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    $(".best-sellers-slider2").slick("unslick");
    slickInit();
  });

  /**/
  $('.product-single__photo-wrapper a[data-fancybox]').fancybox({
    loop : true,
    arrows: true,
    infobar: true,
    isHiddenControls: false,
    zoom: false,
    afterLoad : function(instance, current) {
      /*console.log(instance);
      console.log(current);*/
      if ($('.fancybox-container.fancybox-is-open').length) {
        /*$('.fancybox-container.fancybox-is-open').addClass('fancybox-show-toolbar');
        $('.fancybox-container.fancybox-is-open').addClass('fancybox-show-infobar');
        $('.fancybox-container.fancybox-is-open').addClass('fancybox-show-nav');*/

      }
    }
  });
  /**/



  //   $('body').on('change keyup', '.cart__qty-input.text-box.text-box--x-small',function() {
  //     $(this).closest('.table__quantity').find('.sec-btn.cart__edit.cart__update-wrapper button').click();
  //   });


  /* Delay Function for Cart Quantity starts  */

  function throttle(f, delay){
    var timer = null;
    return function(){
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = window.setTimeout(function(){
        f.apply(context, args);
      },
                                delay || 5000);
    };
  }

  $('body').on('change keyup', '.cart__qty-input.text-box.text-box--x-small',throttle(function() {
    $(this).closest('.table__quantity').find('.sec-btn.cart__edit.cart__update-wrapper button').click();
  }));


  /* Delay Function for Cart Quantity  ends */

});




/*====================================
=            ON DOM READY            =
====================================*/
$(function() {   

});


/*========================================
=            CUSTOM FUNCTIONS            =
========================================*/
function toggleNav() {
  if ($('#site-wrapper').hasClass('show-nav')) {
    // Do things on Nav Close
    $('#site-wrapper').removeClass('show-nav');

  } else {
    // Do things on Nav Open
    $('#site-wrapper').addClass('show-nav');
  }

}





$(".close-icon").click(function(e){
  e.preventDefault();
  $(".bg-overlay").toggleClass("open");
  //   $(this).animate({scrollTop: 0}, 1000);
  //   $(this).animate("", 1000);
  $("html,body").toggleClass("scroll-hidden");   
  toggleNav(); 



});






setTimeout(function(){ 
  if ($('html').hasClass('scroll-hidden')) {
    $('html').removeClass('scroll-hidden');
  }
  if ($('body').hasClass('scroll-hidden')) {
    $('body').removeClass('scroll-hidden');
  }
  if ($('.bg-overlay').hasClass('open')) {
    $('.bg-overlay').removeClass('open');
  }
  if ($('#site-wrapper').hasClass('show-nav')) {
    $('#site-wrapper').removeClass('show-nav');
  }
}, 7500);


( function() {
  $('#btn-search').on('click', function(e) {

    e.preventDefault();
    $('#search').animate({width: 'toggle'}).focus();

  });


  $('#search').toggle();


}());



$(".subscriptionme").click(function () {
  $("#myModal").modal("hide");
});

if ($(window).width() < 1023) { 

$('.ftrbox > .footer-block  > .title').on("click", function(e) {

  $(this).next('.collapsed-content').find('ul').slideToggle(600);
  $(this).toggleClass("open");
  e.stopPropagation();
  e.preventDefault();
});

}

$('body').on('click', '.shopify-challenge__button', function(){
  $('html,body').animate({
    scrollTop: $("footer.page-footer").offset().top-30},
                         'slow');
});




/*---------------- best-sellers ------------------*/
//   $('.testimonial-slider').slick({
//     dots: true,
//     infinite: true,
//     speed: 1000,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     adaptiveHeight: true,
//     arrows: true,
//     responsive: [{
//       breakpoint: 1301,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
//                  {
//                    breakpoint: 1200,
//                    settings: {
//                      slidesToShow: 1,
//                      slidesToScroll: 1
//                    }
//                  },
//                  {
//                    breakpoint: 992,
//                    settings: {
//                      slidesToShow: 1,
//                      slidesToScroll: 1
//                    }
//                  },
//                  {
//                    breakpoint: 768,
//                    settings: {
//                      rows: 2,
//                      slidesToShow: 1,
//                      slidesToScroll: 1
//                    }
//                  },
//                  {
//                    breakpoint: 481,
//                    settings: {
//                      rows: 2,
//                      slidesToShow: 1,
//                      slidesToScroll: 1
//                    }
//                  }

//                 ]
//   });

//    $('.sidebar-wrap').on("click", ".categories-size", function(e) {
//     $(this).next('.categories-content').slideToggle(600);
//     $(this).find('span').toggleClass('ion-plus ion-minus');
//     e.stopPropagation();
//     e.preventDefault();
//   });

//$('.sidebar-wrap').on("click", "a.sub-ul span", function(e) {
/*$(this).parent().parent().find('.subul').slideToggle(600);
    $(this).toggleClass('ion-plus ion-minus');*/

$('.sidebar-wrap').on("click", "a.sub-ul", function(e) {
  $(this).parent().find('.subul').slideToggle(600);
  $(this).find('span').toggleClass('ion-plus ion-minus');
  e.stopPropagation();
  e.preventDefault();
});

$(".sidebar-wrap a.sub-ul").each(function () {
  if ($(this).hasClass('active')) {
    $(this).parents('.filters-box').find('.categories-content').slideToggle(600);
    $(this).parents('.filters-box').find('.categories-size span').toggleClass('ion-plus ion-minus');
    $(this).parent().find('.subul').slideToggle(600);
    $(this).find('span').toggleClass('ion-plus ion-minus');
  }
});

$(".sidebar-wrap label.check.active").each(function () {
  $(this).closest('.filters-box').find('.categories-content').slideToggle(600);
  $(this).closest('.filters-box').find('.categories-size span').toggleClass('ion-plus ion-minus');
});

$('.home-testimonial-slider').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,    
  arrows: true,
  responsive: [{
    breakpoint: 1301,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  },
               {
                 breakpoint: 1200,
                 settings: {
                   slidesToShow: 1,
                   slidesToScroll: 1
                 }
               },
               {
                 breakpoint: 992,
                 settings: {
                   slidesToShow: 1,
                   slidesToScroll: 1
                 }
               },
               {
                 breakpoint: 768,
                 settings: {
                   rows: 2,
                   slidesToShow: 1,
                   slidesToScroll: 1
                 }
               },
               {
                 breakpoint: 481,
                 settings: {
                   rows: 2,
                   slidesToShow: 1,
                   slidesToScroll: 1
                 }
               }

              ]
});


 $(function() { 

 /*start: product details thumb slider*/
  $('.shop-slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    centerMode: false,
    vertical: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          vertical: false,
           arrows: true
        }
      }, 
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
            arrows: true
        }
      },
      {
        breakpoint: 381,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: false,
            arrows: true
        }
      }
    ]
  });

  $('.shop-slider-nav .slick-current').find('.thumb-container').addClass('custom-border');
  $('.shop-slider-nav').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(".shop-slider-nav .slick-slide").each(function () {
      $(this).find('.thumb-container').removeClass('custom-border');
    });
    $('.shop-slider-nav .slick-current').find('.thumb-container').addClass('custom-border');
  });
  /*end: product details thumb slider*/
  
 });
